import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    search: null,
    nowProcessingItemWithId: null,
    savingInProgress: false,
    fetched: false,
    goods_incoming: [],
    goods_writeoff: [],
    goods_relocation: [],
    goods_incoming_item: null,
    goods_writeoff_item: null,
    goods_relocation_item: null,
    itemsTotalCount: null,
    tableOptions: {
      page: 1,
      last_page: 1,
      itemsPerPage: 10,
      sortBy: ["id"],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
    },
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    addOneGoodMovementBaseToState(state, data) {
      let object = state[data.type];
      object.unshift(data.data);
      updateField(state, { path: data.type, value: object });
      //Clone the array to trigger a UI update
      state[data.type] = [...state[data.type]];
    },
    updateOneGoodMovementBaseInState(state, data) {
      let existsAtIndex = state[data.type].findIndex(
        (u) => u.id === data.data.id
      );
      if (existsAtIndex !== -1) {
        state[data.type][existsAtIndex] = data.data;
      }
      //Clone the array to trigger a UI update
      state[data.type] = [...state[data.type]];
    },
  },
  actions: {
    async update({ commit, state, dispatch }, payload) {
      updateField(state, {
        path: "nowProcessingItemWithId",
        value: payload.id,
      });
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .put(this._vm.$apiURL + "/goods_movement_bases/" + payload.id, payload)
        .then((response) => {
          if (
            response.data &&
            response.data.status === "success" &&
            response.data.updated
          ) {
            this._vm.$inform(this._vm.i18n.t("common.operation_success"));
            //updateField(state, { path: response.data.updated.goods_movement_document_type.type+'_item', value: response.data.updated });

            commit("updateOneGoodMovementBaseInState", {
              data: response.data.updated,
              type: response.data.updated.goods_movement_document_type.type, //тип Основания для движения товара на складе, например goods_incoming
            });
          }
          return response.data.updated;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
          if (
            error.response &&
            error.response.data &&
            error.response.data.updated
          ) {
            commit("updateOneGoodMovementBaseInState", {
              data: error.response.data.updated,
              type: error.response.data.updated.goods_movement_document_type
                .type, //тип Основания для движения товара на складе, например goods_incoming
            });
            return error.response.data.updated;
          }
          return false;
        })
        .finally(() => {
          updateField(state, { path: "nowProcessingItemWithId", value: null });
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async store({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .post(this._vm.$apiURL + `/goods_movement_bases`, payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.success_add"));
          if (response.data.new.id > 0) {
            commit("addOneGoodMovementBaseToState", {
              data: { ...response.data.new },
              type: response.data.new.goods_movement_document_type.type, //тип Основания для движения товара на складе, например goods_incoming
            });
            return response.data.new;
          }
          return false;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async get({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      return await axios
        .get(this._vm.$apiURL + `/goods_movement_bases`, {
          params: {
            find_string: state.search,
            type: payload.type,
            page: state.tableOptions.page,
            itemsPerPage: state.tableOptions.itemsPerPage,
            sortBy: state.tableOptions.sortBy[0],
            sortDesc: state.tableOptions.sortDesc[0],
          },
        })
        .then((response) => {
          updateField(state, { path: payload.type, value: response.data });
          updateField(state, {
            path: "itemsTotalCount",
            value: parseInt(response.data.total),
          });
          updateField(state, { path: payload.type, value: response.data.data });
          updateField(state, {
            path: "tableOptions.page",
            value: parseInt(response.data.current_page),
          });
          updateField(state, {
            path: "tableOptions.last_page",
            value: parseInt(response.data.last_page),
          });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    async getOne({ commit, state, dispatch }, payload) {
      updateField(state, { path: "nowProcessingItemWithId", value: payload });
      return axios
        .get(this._vm.$apiURL + "/goods_movement_bases/" + payload.id)
        .then((response) => {
          updateField(state, {
            path: payload.type + "_item",
            value: response.data.data,
          });
          return response.data.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "nowProcessingItemWithId", value: null });
        });
    },
  },
};
